
import { useWindownSize } from "@/helpers";
import { defineComponent, onUnmounted } from "vue";
import { Button3 } from "@/uikit";

export default defineComponent({
  components: { Button3 },
  setup() {
    const { vw, vh, remove } = useWindownSize();
    onUnmounted(() => {
      remove();
    });
    return { vw, vh };
  }
});
